import React, { Component } from 'react';
import Overlay from '../FeatureComponents/Overlay';
import styled from "styled-components"
import closePopup from '../../../assets/imgs/close.svg';
import Axios from 'axios';
// import Star1 from '../../../assets/imgs/star1.png';
// import Star3 from '../../../assets/imgs/star3.png';
// import Star5 from '../../../assets/imgs/star5.png';
import Done from '../../../assets/imgs/Done.gif';
import Email from '../../../assets/imgs/e-mail.png';
import Phone from '../../../assets/imgs/phone.png';
import {wrapperEndPoint} from "../../Utils/Api";

const Star1 = require("../../../assets/imgs/star1.gif");
const Star3 = require("../../../assets/imgs/star3.gif");
const Star5 = require("../../../assets/imgs/star5.gif");


const overallFeedbackData= [{
    id:"star1",
    title: "We’re sorry! Kindly let us know what could have been handled better?",
    options: [" Response Accuracy", "Query Resolution" ,"Ease of Transacting","Others"],
    gif: Star1

},{
    id:"star2",
    title: "We’re sorry! Kindly let us know what could have been handled better?",
    options: [" Response Accuracy", "Query Resolution" ,"Ease of Transacting","Others"],
    gif: Star1
},{
    id:"star3",
    title: "Thank You! Kindly let us know where can we improve?",
    options: [" Response Accuracy", "Query Resolution" ,"Ease of Transacting","Others"],
    gif: Star3 
},{
    id:"star4",
    title: "Thank You! Kindly let us know where can we improve?",
    options: [" Response Accuracy", "Query Resolution" ,"Ease of Transacting","Others"],
    gif: Star3
},{
    id:"star5",
    title: "Great! What did you like the most?",
    options: ["Instant Response", "User-Friendly" ,"Successful Transaction","Others"],
    gif: Star5
}]


class OverlayFeedback extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showThankyouScreen: false,
            showStarGIF: true,
            mobileNo:'',
            emailID:'',
        }
        this.selectedRating = this.props.selectedRating;

        this.sendData = {
            star: "",//make string
            botid: "277",
            feedback:"",//option
            emailID:"",
            mobileNo:"",
            comment:""
        
        }

        this.sendData.star = String(this.selectedRating);
        
    }
 
handleClose = () => {
  this.props.toggleOverlayFeedback(this.selectedRating);
  this.props.closeFlag?this.props.handleModalToggle(true):null;

        Axios.post(wrapperEndPoint.feedbackURL, this.sendData)
          .then(response => response.sendData)
          .then(response => {
          
               console.log(response);//handle sucess
          
           }).catch(error => {
              console.log(error);//handle error
           });
}

handleDone = () => {
    if(this.state.mobileNo === "" && this.state.emailID === ""){
        this.props.toggleOverlayFeedback(this.selectedRating);
        this.props.closeFlag?this.props.handleModalToggle(true):null;
    }else{
        var isMobileNoVerified = false;
        var isEmailVerified = false;
        const numberRegex = /^(\+\d{1,3}[-]?)?\d{10}$/;
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        this.sendData.emailID = this.state.emailID;
        this.sendData.mobileNo = this.state.mobileNo;

        emailRegex.test(this.state.emailID)?isEmailVerified = true:isEmailVerified = false;
        numberRegex.test(this.state.mobileNo)?isMobileNoVerified = true:isMobileNoVerified = false;
        
        if(isEmailVerified === true || this.state.emailID === ""){
            document.getElementById("emailError").style.display="none";
        }else if(isEmailVerified === false){
            document.getElementById("emailError").style.display="block";
        }
        if(isMobileNoVerified === true || this.state.mobileNo === ""){
            document.getElementById("mobileError").style.display="none";
        }else if(isMobileNoVerified === false){
            document.getElementById("mobileError").style.display="block";
        } 
        let Flag = false;
        if((isMobileNoVerified === true && this.state.emailID === "")||
        (this.state.mobileNo === "" && isEmailVerified === true)||
        (isMobileNoVerified === true && isEmailVerified === true)){
            Flag = true;
        }

        if(Flag){
        
            Axios.post(wrapperEndPoint.feedbackURL, this.sendData)
              .then(response => response.sendData)
              .then(response => {
                   console.log(response);//handle sucess
            }).catch(error => {
                  console.log(error);//handle error
            });
            this.props.toggleOverlayFeedback(this.selectedRating);
            this.props.closeFlag?this.props.handleModalToggle(true):null;
        }
    }
}

handleInputOther = (event) => {
      this.sendData.comment = event.target.value; 
}

handleInputEmail = (event) => {
        this.setState({emailID:event.target.value })
}

handleInputMobile = (event) => {
//!((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))
    const numberRegex = /^\d*$/;
    if (event.target.value === '' || numberRegex.test(event.target.value)) {
        this.setState({
            mobileNo:event.target.value
        })
    } 
}

handleSubmit = () => {

  //  if(this.sendData.option != "" ){
    if(this.sendData.feedback == "Others"){
        if(this.sendData.comment != ""){
            this.setState({
                showThankyouScreen : true
            })
        }else{
            //show error mesage
            document.getElementById("otherError").style.display="block";
        }
    }else{
        this.setState({
            showThankyouScreen : true
        })
    }
}   

handleOptions(option, index){
   let x = document.getElementById("feedback-options-wrapper").querySelectorAll('.option');
    x.forEach(item=>{//not working ie
        item.classList.remove('fb-selected')
    })

    this.sendData.feedback = option;
    document.getElementById("feedback-options-wrapper").querySelectorAll('.option')[index].classList.add('fb-selected')
    if(option == "Others"){
        document.getElementById("otherWrapperId").style.display="block";
        this.setState({ showStarGIF:false})
    }else{
        document.getElementById("otherWrapperId").style.display="none";
        this.setState({showStarGIF:true})
    }
}

render(){
    return (
        <PopUpOverlay>
            <PopUpContent>
            <img className="cross" onClick={()=>{this.handleClose()}} src={closePopup} alt="close popup"></img>
            {!this.state.showThankyouScreen?
            <div>
                {this.state.showStarGIF?
                <div className="gif-wrapper">
                       
                <div className="gif-div">
                <img className="gif-img" src= {overallFeedbackData[this.selectedRating-1].gif} ></img></div>
            
                </div>
             
                : <LineSpace></LineSpace>
                }
                <div className="Content-wrapper">
                <div className="title">
                   {overallFeedbackData[this.selectedRating-1].title} 
                </div>
                <div className="options-wrapper" id={"feedback-options-wrapper"}>
                   {overallFeedbackData[this.selectedRating-1].options.map((item,i)=>{
                       return(
                           <div className="option" id={i} key={i} onClick={()=>this.handleOptions(item, i)}>
                               {item}
                           </div>
                       )
                   })
                   }
                   <div className="other-option-wrapper" id="otherWrapperId">
                        <textarea className="other-input"  onChange={()=>this.handleInputOther(event)} placeholder="Please add your comment" maxLength="120"></textarea>
                        <div className="errorBlock" style={{textAlign: "left", marginLeft: "25px"}} id="otherError">Please specify one</div> 
                   </div>
                </div>
              
                <Button primary id="submitId" type="text" onClick={()=>{this.handleSubmit()}}>Submit</Button>
                </div>
            </div>
            :
            <div>
                <div className="gif-wrapper">
                    <div className="gif-div">
                        <img className="gif-img" src={Done}></img>
                    </div>
                </div>
                <div className="feedback-wrapper">
                <div style={{width:"85%", margin: "0px auto"}}>
                <LineSpace></LineSpace>
               <div className="feedback-title">Thank you for your feedback!</div>
               {this.props.isLoginUser || this.selectedRating == 5?  
               <div className="feedback-subTitle">
                   We assure you of our best services at all times. 🙂
                </div>
               :
               <div>
                <div className="feedback-form-wrapper">
                   <div className="feedback-form-title">Please provide your email id/mobile number to support you further.</div>
                   <LineSpace></LineSpace>
                   <div className="form-wrapper">
                        <label className= "form-label">Email ID: </label><br></br>
                        <div className="form-input-wrapper">
                        <input className= "form-input" 
                         onChange={()=>this.handleInputEmail(event)} placeholder="Enter your Email ID">

                        </input>
                        <img src={Email} id="input_img"></img>
                        </div>
                        <div className="errorBlock" id="emailError">Invalid Email ID</div> 
                       
                   </div>
                   <LineSpace></LineSpace>
                   <div className="form-wrapper">
                        <label className= "form-label">Mobile Number: </label><br></br>
                        <div className="form-input-wrapper">
                        <input className= "form-input" value={this.state.mobileNo} type="tel"
                         onChange={()=>this.handleInputMobile(event)} placeholder="Enter your Mobile Number" maxLength="10">
                         
                        </input>
                        <img src={Phone} id="input_img"></img>
                        </div>
                        <div className="errorBlock" id="mobileError">Invalid Mobile Number</div> 
                   </div>
                   <LineSpace></LineSpace>
                </div>

                <ActionButton 
                    onClick={()=>this.handleDone()} >Done</ActionButton>

               </div>}
               </div> </div>
            </div>}
            </PopUpContent>
        </PopUpOverlay>
    );
  }
};

const PopUpOverlay = styled(Overlay)`
    top : 0;
    background : rgba(0,0,0,0.31);
    height: 100%;
    display : flex;
    justify-content : center;
    align-items : center;
    border-radius : 6px;
    z-index:9999999;
`
const PopUpContent = styled.div`
    background : #fcfcfc;
    position : relative;
    width: 92%;
    height: 92%;
    border-radius : 5px;
    z-index:9999999;

    .Content-wrapper{
        background : #fcfcfc;
        position : relative;
        width: 100%;
        border-radius : 5px;

    }

    .cross {
        position: absolute;
        top: 18px;
        right: 18px;
        cursor: pointer; 
        height:12px;
        width:12px;
        z-index: 9999999;
    }

    .gif-wrapper{
        background: #fff;
        width: 100%;
        padding: 10px 0 0 0;
        border-bottom: 1.5px solid #f4f4f4;
      //  border-radius: 15px 50px 30px 5px:
    }

    .gif-div{
        height: 140px;
        width: 140px;
        margin: 20px auto;
        vertical-align: middle;

    }

    .gif-img{
        width: 100%;
    }

    .title{
        font-size: 18px;
        font-weight: 500;
        color: #2c387a;
        padding-top:30px;
        text-align : center;
     
    }

    .options-wrapper{
        margin : 16px 0 16px 0;
        height: auto;
        vertical-align: middle;
        text-align: centre;
    }

    .option{
        height:45px;
        width: 85%;
        margin: 12px auto;
        padding: 13px;
        background: #fff;
        border: 0.5px solid #fff;
        border-radius: 8px;
        box-shadow: 0px 8px 8px rgba(0,0,0,0.1);
        cursor: pointer;
        vertical-align: middle;
        text-align:center;
        font-size: 14px;
    }

    .fb-selected{
        background: #2c387a;
        color: #ffffff
        border: 0.5px solid #2c387a;
        font-weight: 500;
    }

    .other-option-wrapper{
        display: none;
        text-align : center;
    }

    .other-input{
        display: inline-block;
        width: 85%;
        padding: 10px;
        height: 140px;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        font-family: Roboto, sans-serif;
        font-size:14px;
    }

    .feedback-wrapper{
        height: 100%;
        vertical-align: middle;
        background: #fcfcfc;
        width: 100%;
    }

    .feedback-title{
        margin-bottom: 8px;
        font-size: 18px;
        font-weight: 500;
        color: #2c387a;
        margin-top:5px;
        text-align : center;
    }

    .feedback-subTitle{
        font-size: 18px;
        color: #666666;
        text-align : center;
        margin-top:10px;
        
    }

    .feedback-form-wrapper{
        color: #666666;
        background: #fcfcfc;

    }

    .feedback-form-title{
        margin-bottom: 10px;
        text-align : center;

    }

    .form-wrapper{
        width: 100%;
        padding:0;
        margin:0;
    
    }

    .form-label{
        padding-left: 6px;
        color: #76769a;
        font-weight:440;

    }

    .form-input-wrapper{
        position:relative;
       

    }
    .form-input{
        width: 90%;
        padding: 4px 0px;
        padding-left: 30px
        margin: auto; 
        height:40px;  
        outline: 0;     
        border: none;
        border-bottom: 1px solid #ccc;
        background-color:#fcfcfc;    
        box-sizing: border-box; 

    }

    #input_img {
        position:absolute;
        bottom:12px;
        left:6px;
        width:18px;
        height:16px;
    }
    
    .errorBlock{
        font-size: 12px;
        padding-left: 6px;
        margin-buttom:8px;
        margin-top: 2px;
        color: red;
        display: none;

    }

`

const LineSpace = styled.div`
      width: 100%;
      height:20px;
      background: #fcfcfc;
`

const Button = styled.button`
    border: 0;
    color: white;
    height: 45px;
    display: block;
    font-size: 14px;
    border-radius: 8px;
    padding: 0 10px;
    width: 85%;
    font-weight: 600;
    box-shadow : none;
    outline : 0;
    margin: 15px auto;
    color : ${props=>{
        return props.primary ? '#fff' : '#2c387a'
    }};
    background : ${props=>{
        return props.primary ? '#2c387a' : '#fff'
    }};
    border : ${props=>!props.primary && '1px solid #2c387a'};
    cursor: pointer;
  
`

const ActionButton = styled.div`
  width: 100%;
  margin: 10px auto;
  border: 0px solid #2c387a;
  background: #2c387a;
  color: #fff;
  height: 45px;
  display: block;
  font-size: 14px;
  border-radius: 5px;
  padding: 14px;
  cursor: pointer;
  text-align : center;
  font-weight: 600;
`

export default OverlayFeedback;